import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-344b286a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex flex-1 items-center justify-between" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-[#4535D8]" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  님 안녕하세요! ")
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "absolute bottom-[-61px] right-0 flex h-[46px] items-center justify-center rounded-[25px] bg-white py-3 px-[30px] transition-all duration-300",
  style: {"box-shadow":"0px 2px 8px rgba(199, 187, 173, 0.2)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DefaultContainer = _resolveComponent("DefaultContainer")!

  return (_openBlock(), _createBlock(_component_DefaultContainer, { class: "fixed top-0 z-10 h-20 border-b-[1px] border-solid border-[rgba(131,144,165,0.3)] bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: require('@assets/logo/amy_logo.png'),
            alt: "amy logo",
            class: "mr-[70px] h-[38px] cursor-pointer",
            onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push({ name: 'VideoList' }))
          }, null, 8, _hoisted_3),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, idx) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: `menu-${idx}`,
              class: _normalizeClass(["mr-[38px] text-[14px] font-normal leading-[160%] tracking-[-0.025em]", [{ 'text-[#4535D8]': _ctx.$route.name === menu.to }]]),
              to: { name: menu.to }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(menu.label), 1)
              ]),
              _: 2
            }, 1032, ["class", "to"]))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "relative",
          tabindex: "0",
          onFocusout: _cache[3] || (_cache[3] = () => (_ctx.menuOpen = false))
        }, [
          _createElementVNode("div", {
            class: "relative flex cursor-pointer items-center text-[14px] font-normal leading-[136%]",
            onClick: _cache[1] || (_cache[1] = () => (_ctx.menuOpen = !_ctx.menuOpen))
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.cookies.get("aUser")), 1),
            _hoisted_5,
            _createElementVNode("img", {
              src: require('@assets/icons/ArrowDown.svg'),
              class: _normalizeClass(["ml-2 transition-all duration-300", [{ '-rotate-180': _ctx.menuOpen }]])
            }, null, 10, _hoisted_6)
          ]),
          _createVNode(_Transition, { name: "appear" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "cursor-pointer text-[14px] font-medium leading-[21px] text-black/60",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
                }, " 로그아웃 ")
              ], 512), [
                [_vShow, _ctx.menuOpen]
              ])
            ]),
            _: 1
          })
        ], 32)
      ])
    ]),
    _: 1
  }))
}